module.exports = __webpack_public_path__ + "static/media/RUR_histogram_data.ab6fad30.csv";